import "./ContactUs.css"
export default () =>
  <div className="contact-us">
    <div>
      <div>
        <img src="/assets/wechat-gzh.jpg" alt="公众号"/>
      </div>
      <span>关注公众号动态早知道</span>
    </div>
    <div>
      <div>
        <img src="/assets/cloudlab-assistant.jpg" alt="小助理微信"/>
      </div>
      <span>有问题请添加云燕小助理微信</span>
    </div>
  </div>